export default __webpack_public_path__ + "static/media/Group3398@2x.21059392.png";